<template>
  <div id="content" v-html="html"></div>
</template>

<script>
import AboutHmtl from './about';

export default {
  name: 'About',
  data() {
    return {
      html: AboutHmtl,
    };
  },
};
</script>

<style scoped>
#content {
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
}
#content >>> p {
  text-align: left !important;
}

#content >>> li,
#content >>> ul {
  text-align: left !important;
}
</style>
